import { toast } from 'react-toastify';
import APIs from '../../apiUrl';

const UserLogin = async (credentials) => {
  try {
    const response = await APIs.post(`/login`, credentials);

    if (response?.data?.message?.toLowerCase() === 'success') {
      toast('Login Successfully');

      await localStorage.removeItem('admin_token');

      APIs.defaults.headers[
        'Authorization'
      ] = `Bearer ${response?.data?.token}`;

      localStorage.setItem('token', response?.data?.token);

      return response.data;
    }
  } catch (error) {
    throw error;
  }
};

const UserRegistration = async (credentials) => {
  try {
    const response = await APIs.post(`/registration`, credentials);

    if (response?.data?.message?.toLowerCase() === 'success') {
      toast('Registration Successfully');
      return response.data;
    }
  } catch (error) {
    toast.error(error.response?.data?.message || 'Registration failed');
    throw error;
  }
};

const getSingleUserDetails = async () => {
  try {
    const response = await APIs.get(`/get_admin_user`);

    console.log(response, 'response');
    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const UserAuthServices = {
  UserLogin,
  UserRegistration,
  getSingleUserDetails,
};

export default UserAuthServices;
